(() => {
  'use strict';
  const dialog = document.getElementById('MJNewsletterDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const params = new URLSearchParams(window.location.search);
  const theme = window.Shopify && window.Shopify.theme;
  // Both Shopify's actual runtime role and the exact staging theme ID are required.
  // A query string can never enable preview on the published theme.
  const isPreview = params.get('mj_newsletter_preview') === '1' && theme &&
    theme.role === 'unpublished' && String(theme.id) === dialog.dataset.previewThemeId &&
    dialog.dataset.themeId === dialog.dataset.previewThemeId;
  const enabled = dialog.dataset.enabled === 'true';
  if (!isPreview && (!enabled || dialog.dataset.blocked === 'true')) return;

  const form = dialog.querySelector('form');
  const input = form.querySelector('input[type="email"]');
  const fieldset = form.querySelector('fieldset');
  const submit = form.querySelector('button[type="submit"]');
  const buttonText = form.querySelector('[data-mj-newsletter-button-text]');
  const initialButtonText = buttonText.textContent;
  const signup = dialog.querySelector('[data-mj-newsletter-signup]');
  const success = dialog.querySelector('[data-mj-newsletter-success]');
  const error = dialog.querySelector('[role="alert"]');
  const review = dialog.querySelector('[data-mj-newsletter-review]');
  const copyButton = dialog.querySelector('[data-mj-newsletter-copy]');
  const copyStatus = dialog.querySelector('[data-mj-newsletter-copy-status]');
  const shopLink = dialog.querySelector('[data-mj-newsletter-shop]');
  const serverStatus = form.querySelector('[data-mj-newsletter-server-status]').dataset.mjNewsletterServerStatus;
  const dismissKey = 'mj.newsletter.dismissed.v1';
  const acceptedKey = 'mj.newsletter.accepted.v1';
  const attemptKey = 'mj.newsletter.attempt.v1';
  const cooldown = 7 * 24 * 60 * 60 * 1000;
  let lastFocus = null;
  let savedOverflow = '';
  let timer;
  const read = (storage, key) => { try { return storage.getItem(key); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, value); } catch (_) {} };
  const remove = (storage, key) => { try { storage.removeItem(key); } catch (_) {} };
  // Access to storage can itself be denied in private/restricted browsers.
  let local, session;
  try { local = window.localStorage; } catch (_) { local = null; }
  try { session = window.sessionStorage; } catch (_) { session = null; }

  const open = () => {
    if (dialog.open || document.visibilityState === 'hidden') return;
    if (!isPreview && document.querySelector('dialog[open]')) {
      timer = window.setTimeout(open, 2500);
      return;
    }
    lastFocus = document.activeElement;
    savedOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    // Focus the heading, not the email input: no surprise mobile keyboard.
    (success.hidden ? dialog.querySelector('#MJNewsletterTitle') : success.querySelector('h2')).focus({ preventScroll: true });
  };
  const dismiss = () => {
    clearTimeout(timer);
    if (!isPreview) write(local, dismissKey, String(Date.now()));
    dialog.close();
  };
  const showSuccess = () => {
    signup.hidden = true;
    success.hidden = false;
    const title = success.querySelector('h2');
    title.id = 'MJNewsletterSuccessTitle';
    dialog.setAttribute('aria-labelledby', title.id);
    dialog.removeAttribute('aria-describedby');
    if (!isPreview && shopLink) {
      const shopPath = shopLink.getAttribute('href');
      shopLink.setAttribute('href', '/discount/MJWELCOME10?redirect=' + encodeURIComponent(shopPath));
    }
    if (dialog.open) title.focus({ preventScroll: true });
  };
  const resetSubmit = () => {
    submit.disabled = false;
    buttonText.textContent = initialButtonText;
    form.removeAttribute('aria-busy');
  };
  fieldset.disabled = false;
  review.hidden = !isPreview;
  if (isPreview) {
    // Defense in depth: a review form has no network submission method.
    form.setAttribute('method', 'dialog');
    form.setAttribute('action', '#');
  }
  dialog.querySelectorAll('[data-mj-newsletter-close]').forEach(button => button.addEventListener('click', dismiss));
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = savedOverflow;
    if (lastFocus && lastFocus.isConnected && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
  });
  input.addEventListener('invalid', () => {
    input.setCustomValidity(dialog.dataset.invalid);
    input.setAttribute('aria-invalid', 'true');
  });
  input.addEventListener('input', () => {
    input.setCustomValidity('');
    input.removeAttribute('aria-invalid');
    error.hidden = true;
  });
  form.addEventListener('submit', event => {
    if (isPreview) {
      event.preventDefault();
      event.stopImmediatePropagation();
      review.textContent = dialog.dataset.reviewSuccess;
      showSuccess();
      return;
    }
    if (!enabled) { event.preventDefault(); return; }
    // Ordinary native POST lets Shopify perform its own consent and CAPTCHA flow.
    write(session, attemptKey, String(Date.now()));
    submit.disabled = true;
    buttonText.textContent = dialog.dataset.loading;
    form.setAttribute('aria-busy', 'true');
    // Restore the control if Shopify's CAPTCHA holds the native submission.
    window.setTimeout(resetSubmit, 12000);
  }, true);
  if (copyButton) copyButton.addEventListener('click', async () => {
    try {
      if (!window.navigator.clipboard || !window.navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
      await window.navigator.clipboard.writeText(copyButton.dataset.code);
      copyButton.textContent = copyButton.dataset.copied;
      copyStatus.textContent = copyButton.dataset.copied;
    } catch (_) {
      copyStatus.textContent = copyButton.dataset.copyFailed;
    }
  });
  window.addEventListener('pageshow', resetSubmit);

  // Customer forms share response flags. Only show this form's feedback when its
  // own submitted hash AND a recent same-tab attempt are both present.
  const attempt = Number(read(session, attemptKey));
  const ownResponse = window.location.hash === '#MJNewsletterForm' && attempt > 0 &&
    Date.now() - attempt >= 0 && Date.now() - attempt < 30 * 60 * 1000;
  if (!isPreview && ownResponse && serverStatus !== 'idle') {
    remove(session, attemptKey);
    if (serverStatus === 'accepted') {
      write(local, acceptedKey, String(Date.now()));
      showSuccess();
    } else {
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
    }
    open();
    return;
  }
  if (isPreview) {
    if (params.get('mj_newsletter_state') === 'success') {
      review.textContent = dialog.dataset.reviewSuccess;
      showSuccess();
    } else if (params.get('mj_newsletter_state') === 'error') {
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
    }
    open();
    return;
  }
  // A logged-in customer may become subscribed during this POST. Resolve the
  // source-bound response above before suppressing future automatic prompts.
  if (dialog.dataset.subscribed === 'true') return;
  const dismissedAt = Number(read(local, dismissKey));
  // Accepted means this device already submitted, not that email is confirmed.
  if (read(local, acceptedKey) || (dismissedAt > 0 && Date.now() - dismissedAt < cooldown)) return;
  timer = window.setTimeout(open, 8000);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && !dialog.open && !read(local, acceptedKey)) {
      const lastDismissal = Number(read(local, dismissKey));
      if (!lastDismissal || Date.now() - lastDismissal >= cooldown) {
        clearTimeout(timer);
        timer = window.setTimeout(open, 8000);
      }
    }
  });
})();
